/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTimelineProps, TdTimelineItemProps } from './type';

export const timelineDefaultProps: TdTimelineProps = {
  labelAlign: 'left',
  layout: 'vertical',
  mode: 'alternate',
  reverse: false,
  theme: 'default',
};

export const timelineItemDefaultProps: TdTimelineItemProps = { dotColor: 'primary' };
